export const FEATURE_HIDE_CONTENT_MODERATION = 'STU-10452-hide-content-moderation'
